<template>
  <div class="common-main">
    <list :categoryOptions="categoryOptions" :virtualWarehouse="virtualWarehouse" :tabType="0" ref="all"></list>
  </div>
</template>

<script>
import API from '@/api'
import list from './components/list.vue'

export default {
  name: 'supply_review',
  components: {
    list
  },
  data() {
    return {
      tabType: 'all',
      virtualWarehouse: [],
      categoryOptions: []
    }
  },
  created() {
    this.getVirtualWarehouseList()
    this.getCategoryList()

  },
  methods: {
    getVirtualWarehouseList() {
      API.getVirtualWarehouseList().then((res) => {
        this.virtualWarehouse = res.data
      })
    },
    // 获取品类列表
    async getCategoryList() {
      let { data } = await API.getCategoryList({ pageNumber: 1, pageSize: 1000 })
      if (data && data.list.length) {
        this.deletechildList(data.list)
        this.categoryOptions = data.list
      }
    },
    deletechildList(arr) {
      // 删除最后一级为空的childList字段
      arr.forEach((item) => {
        if (!item.childList.length) {
          delete item.childList
        } else {
          this.deletechildList(item.childList)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.common-main {
  display: flex;
  height: 100%;
  min-width: 1600px;
  padding: 12px;
  flex-direction: column;
  background-color: #fff;

  .common-header {
    display: flex;
    height: 40px;
    align-items: center;
    // justify-content: space-between;
    .left {
      > * {
        margin-right: 15px;
      }
      .el-input {
        width: 320px;
        .el-select {
          width: 100px;
        }
      }
    }
  }

  .common-section {
    height: calc(100vh - 194px);
    margin: 12px 0;
    .stock-img {
      width: 60px;
      height: 60px;
      border-radius: 4px;
      overflow: hidden;
      border: 1px solid #f5f7fa;
      user-select: none;
      cursor: pointer;
    }
  }

  .common-footer {
    display: flex;
    height: 40px;
    align-items: center;
    justify-content: flex-end;
  }
}

.el-tree-box {
  height: 380px;
  overflow: auto;
}
.filter-album-text,
.filter-category-text {
  margin-bottom: 18px;
}
</style>
